import { useEffect, useState } from 'react';

/*
 * Highlights the in-page tab matching the section nearest the top of the
 * viewport. Takes [{ id, ref }] and returns the active id.
 */
function useConnectScrollSpy (sections) {
    const [active, setActive] = useState(sections[0] && sections[0].id);

    useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') {
            return undefined;
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActive(entry.target.dataset.connectSection);
                }
            });
        }, { rootMargin: '-140px 0px -55% 0px', threshold: 0 });

        sections.forEach(({ id, ref }) => {
            if (ref.current) {
                ref.current.dataset.connectSection = id;
                observer.observe(ref.current);
            }
        });

        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return active;
}

export default useConnectScrollSpy;
